import { type FunctionComponent } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { QuestionItems } from '../questionItems/QuestionItems';

import { type SellerItems_question$data } from './__generated__/SellerItems_question.graphql';

type Props = {
    question: SellerItems_question$data;
};

const SellerItemsComponent: FunctionComponent<Props> = ({ question }) => {
    const sellerItems = question?.sellerItems?.edges || [];
    const answerAuthor = question?.answers?.[0]?.author;
    const sellerPreferences = answerAuthor?.sellerPreferences;
    const storefrontUrl = sellerPreferences?.storefrontUrl;
    const label = sellerPreferences?.label;
    const sellerVertical = answerAuthor?.vertical;

    if (sellerItems.length && label && storefrontUrl && sellerVertical) {
        return (
            <QuestionItems
                items={sellerItems}
                url={`/dealers/${storefrontUrl}/`}
                title={label}
                vertical={sellerVertical}
            />
        );
    }
    return null;
};

export const SellerItems = createFragmentContainer(SellerItemsComponent, {
    question: graphql`
        fragment SellerItems_question on QuestionType {
            answers {
                author {
                    vertical
                    sellerPreferences {
                        label
                        storefrontUrl
                    }
                }
            }
            sellerItems {
                edges {
                    node {
                        item {
                            ...ItemTile_item
                            serviceId
                            title
                        }
                    }
                }
            }
        }
    `,
});
